/* eslint-disable @typescript-eslint/naming-convention */
import { Card, Text } from '@servicetitan/anvil2';
import { ProviderDisclosures } from '@servicetitan/financing-provider-assets';
import { agreementCard } from './Agreement.module.scss';

export const Agreement = () => {
    return (
        <Card
            flexDirection="column"
            alignSelf="center"
            alignItems="center"
            className={agreementCard}
        >
            <Text variant="headline" el="h3" size="small">
                {ProviderDisclosures.serviceFinance.esignAgreementTitle}
            </Text>
            <Text variant="headline" el="h3" size="small">
                {ProviderDisclosures.serviceFinance.esignAgreementSubTitle}
            </Text>
            <Text
                variant="body"
                size="small"
                dangerouslySetInnerHTML={{
                    __html: ProviderDisclosures.serviceFinance.esignAgreement,
                }}
            />
        </Card>
    );
};
